export const QUERY_PARAMS_KEY = {
  currentPage: 'currentPage',
  pageSize: 'pageSize',
  tab: 'tab',
  token: 'token',
  period: 'period'
} as const

export const DEFAULT_SHARED_QUERY_PARAM_KEYS: string[] = []
